<template>
  <div class="rec-trainns-cont">
    <div class="rec-trainns-head">
      <h3>Polecane szkolenia i warsztaty on-line</h3>
      <p>Wartościowe treści dla usługodawców i właścicieli zwierząt.</p>
    </div>
    <div class="rec-trainns-grid">
      <article class="train-card">
        <div class="train-card__cover train-card__cover--1"></div>
        <div class="train-card__body">
          <span class="tag">Dla biznesu • Groomer</span>
          <h4>Podstawy groomingu - warsztaty online</h4>
          <p>Poznaj tajniki pielęgnacji sierści, dobór sprzętu i podstawowe techniki strzyżenia psów.</p>
          <a href="#"><ButtonVue bgColor="#10b981" color="#fff" text="Sprawdź ofertę" /></a>
        </div>
      </article>
      <article class="train-card">
        <div class="train-card__cover train-card__cover--2"></div>
        <div class="train-card__body">
          <span class="tag">Dla właścicieli • Behawiorysta</span>
          <h4>Jak zrozumieć swojego psa?</h4>
          <p>Webinar o mowie ciała psów i skutecznych sposobach reagowania na stres zwierzęcia.</p>
          <a href="#"><ButtonVue bgColor="#10b981" color="#fff" text="Sprawdź ofertę" /></a>
        </div>
      </article>
      <article class="train-card">
        <div class="train-card__cover train-card__cover--3"></div>
        <div class="train-card__body">
          <span class="tag">Dla wszystkich • Pierwsza pomoc</span>
          <h4>Pierwsza pomoc dla zwierząt</h4>
          <p>Niezbędny kurs ratujący życie: RKO, opatrywanie ran i postępowanie w sytuacjach awaryjnych.</p>
          <a href="#"><ButtonVue bgColor="#10b981" color="#fff" text="Sprawdź ofertę" /></a>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import ButtonVue from '@/components/Button.vue';

export default {
  name: "TrainingsVue",
  components: { ButtonVue }
};
</script>

<style scoped>
.rec-trainns-head {
  text-align: center;
  margin-bottom: 28px;
}
.rec-trainns-head h3 {
  margin-bottom: 8px;
}
.rec-trainns-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}
.train-card {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(0, 0, 0, .08);
}
.train-card__cover {
  height: 180px;
  background-size: cover;
  background-position: center;
}
.train-card__cover--1 { background-image: url('https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?auto=format&fit=crop&w=600&q=80'); }
.train-card__cover--2 { background-image: url('https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&w=600&q=80'); }
.train-card__cover--3 { background-image: url('https://images.unsplash.com/photo-1581888227599-779811939961?auto=format&fit=crop&w=600&q=80'); }
.train-card__body {
  padding: 16px;
}
.tag {
  display: inline-block;
  font-size: 1.2rem;
  background: #ecfdf5;
  color: #10b981;
  border-radius: 999px;
  padding: 4px 10px;
}
@media (max-width: 1024px) {
  .rec-trainns-grid {
    grid-template-columns: 1fr;
  }
}
</style>